import React from 'react';
import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

type FormTextareaProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    placeholder?: string;
    rows?: number;
    domainConfiguration: DomainConfigurationDto;
};

export default function FormTextarea<T extends FieldValues>({
    name,
    label,
    register,
    registerOptions,
    placeholder,
    rows = 4,
    domainConfiguration
}: FormTextareaProps<T>) {
    return (
        <div className="space-y-3">
            <label
                className="block text-body-14 font-semibold"
                style={{ color: domainConfiguration.style.onSurfaceColor }}>
                {label}
            </label>
            <textarea
                rows={rows}
                {...register(name, registerOptions)}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)]"
                style={
                    {
                        borderColor: withOpacity(domainConfiguration.style.onSurfaceColor, 0.3),
                        backgroundColor: 'transparent',
                        color: domainConfiguration.style.onSurfaceColor
                    } as React.CSSProperties
                }
                placeholder={placeholder}
            />
        </div>
    );
}
